//      
var interpolator = /\{\{\s*(.*?)\s*\}\}/g;

//      


// Load the interpolate logic
// Perform
var translate = (function (converter) {
  return function (input) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Load the output
    var output = converter(input);

    // Interpolate before return
    var match = function match(v, k) {
      return data[k] != null ? data[k] : "";
    };

    // Interpolate
    return output.replace(interpolator, match);
  };
});

//      


// Load the data
// Setup a pseudo map
var map = {
  a: "ą",
  b: "ɓ",
  c: "ƈ",
  d: "ɗ",
  e: "ę",
  f: "ƒ",
  g: "ɠ",
  h: "ɦ",
  i: "į",
  j: "ĵ",
  k: "ƙ",
  l: "ĺ",
  m: "ɱ",
  n: "ɲ",
  o: "ǫ",
  p: "ƥ",
  q: "ɋ",
  r: "ɽ",
  s: "ȿ",
  t: "ƭ",
  u: "ų",
  v: "ʋ",
  w: "ⱳ",
  x: "ẋ",
  y: "ƴ",
  z: "ȥ",
  A: "Ą",
  B: "Ɓ",
  C: "Ƈ",
  D: "Ɗ",
  E: "Ę",
  F: "Ƒ",
  G: "Ɠ",
  H: "Ɦ",
  I: "Į",
  J: "Ĵ",
  K: "Ƙ ",
  L: "Ĺ",
  M: "Ɱ",
  N: "Ɲ",
  O: "Ǫ",
  P: "Ƥ",
  Q: "Ɋ",
  R: "Ɽ",
  S: "Ȿ",
  T: "Ƭ",
  U: "Ų",
  V: "Ʋ",
  W: "Ⱳ",
  X: "Ẋ",
  Y: "Ƴ",
  Z: "Ȥ"
};

// Replace
var pattern = /[a-z]/gi;

// Match
var match = function match(c) {
  return map[c];
};

// Create pseudo converter
// This allows matching correctly
var pseudo = (function (input) {
  // Keep track of the matches
  var matches = {};

  // Setup the string
  var s = input.replace(interpolator, function (v, k, i) {
    // Cache the value
    matches[i] = k;

    // Set the key
    return "{{ " + i + " }}";
  }).replace(pattern, match).replace(interpolator, function (v, k) {
    return "{{ " + matches[k] + " }}";
  });

  // Return the interpolated string
  return "[~" + s + "~]";
});

//      

// Load the exported files

export { translate as createTranslate, interpolator, pseudo as pseudoConvert };
